// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const QrIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="qr" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Combined-Shape" fill="#FFF" d="M1 1h6v6H1zm0 10h6v6H1zm16-4h-6V1h6z" /><path id="Combined-Shape" fill="currentColor" fillRule="nonzero" d="M0 8h8V0H0zm2-6h4v4H2zM0 18h8v-8H0zm2-6h4v4H2zm8-12v8h8V0zm6 6h-4V2h4zm2 10v2h-2v-2zm-4 0v2h-2v-2zm2-2v2h-2v-2zm-4 0v2h-2v-2zm2-2v2h-2v-2zm4 0v2h-2v-2zm-6-2v2h-2v-2zm4 0v2h-2v-2z" /></g></svg>
))
